
import {bus} from "../autoload/_vue";

export default {
    data() {
        return {
            bus,
            title   : '',
            additional   : '',
            content : '',
            tables  : [],
            slider  : []
        }
    },
    created() {
        bus.$on('update-content', ({title, additional, content, tables, slider}) => {
            this.title   = title;
            this.additional   = additional;
            this.content = content;
            this.tables = tables;
            this.slider = slider;
        });
    },
    updated: function () {
      this.$nextTick(function () {
        if(this.slider && this.slider.length) {
          if(this.lightSlider) {
            this.lightSlider.destroy();
            this.lightSlider = null;
          }
          this.lightSlider = jQuery('#dropdownSideContent .gallery-slider').lightSlider({
            item        : 1,
            auto        : true,
            loop        : true,
            pause       : 7000,
            gallery     : true,
            thumbItem   : 6,
            slideMargin : 0,
          });
        }
      })
    }
}
